// Header language dropdown (snippets/header-language-switcher.liquid).
// Disclosure button + menu of submit buttons. Closes on outside click, Escape, or tabbing away.
if (!customElements.get('header-language-dropdown')) {
  customElements.define(
    'header-language-dropdown',
    class HeaderLanguageDropdown extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.lang-dropdown__toggle');
        this.menu = this.querySelector('.lang-dropdown__menu');
        this.options = Array.from(this.querySelectorAll('.lang-dropdown__option'));

        this.onDocumentClick = (event) => {
          if (!this.contains(event.target)) this.close();
        };

        this.toggle.addEventListener('click', () => (this.isOpen() ? this.close() : this.open()));
        this.toggle.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            this.open(event.key === 'ArrowUp' ? this.options.length - 1 : this.currentIndex());
          }
        });

        this.menu.addEventListener('keydown', (event) => this.onMenuKeydown(event));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.isOpen()) {
            event.preventDefault();
            this.close();
            this.toggle.focus();
          }
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        });

        // Choosing the language already shown just closes the menu instead of reloading.
        this.options.forEach((option) =>
          option.addEventListener('click', (event) => {
            if (option.hasAttribute('aria-current')) {
              event.preventDefault();
              this.close();
              this.toggle.focus();
            }
          })
        );
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      currentIndex() {
        const index = this.options.findIndex((option) => option.hasAttribute('aria-current'));
        return index === -1 ? 0 : index;
      }

      open(focusIndex) {
        this.menu.hidden = false;
        this.toggle.setAttribute('aria-expanded', 'true');
        this.classList.add('is-open');
        document.addEventListener('click', this.onDocumentClick);
        if (typeof focusIndex === 'number') this.options[focusIndex].focus();
      }

      close() {
        if (!this.isOpen()) return;
        this.menu.hidden = true;
        this.toggle.setAttribute('aria-expanded', 'false');
        this.classList.remove('is-open');
        document.removeEventListener('click', this.onDocumentClick);
      }

      onMenuKeydown(event) {
        const index = this.options.indexOf(document.activeElement);
        const last = this.options.length - 1;
        let next = null;

        if (event.key === 'ArrowDown') next = index >= last ? 0 : index + 1;
        if (event.key === 'ArrowUp') next = index <= 0 ? last : index - 1;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = last;

        if (next !== null) {
          event.preventDefault();
          this.options[next].focus();
        }
      }
    }
  );
}
